import { RecoverPasswordRepresentativeCommandResponse } from 'domain/entities/authUser'

export const RepresentativeEmpty = {
  exp: 0,
  firstLogin: false,
  fullName: '',
  iat: 0,
  signed: false,
  show_privacyPolicy_back_office: false,
  show_termsAndConditions_back_office: false,
  user_id: '',
}

export const RepresentativeLocalStorageEmpty = {
  logged: false,
  refreshToken: '',
  representative: RepresentativeEmpty,
  refreshExpiresIn: '',
}

export type Representative = {
  exp: number
  firstLogin: boolean
  fullName: string
  iat: number
  show_privacyPolicy_back_office: boolean
  show_termsAndConditions_back_office: boolean
  signed: boolean
  user_id: string
}

export type RepresentativeLocalStorage = {
  logged: boolean
  refreshToken: string
  representative: Representative
  refreshExpiresIn: number
}

export type TokenLocalStorage = {
  accessToken: string
  accessExpiresIn: number
}

export const TokenLocalStorageEmpty = {
  accessToken: '',
  accessExpiresIn: '',
}

export type PayloadLoginAndRefreshTokenAction = {
  logged: boolean
  representative: Representative
  token: string
  refreshToken: string | undefined
  refreshExpiresIn: number | undefined
  accessExpiresIn: number | undefined
}

export type AuthUserState = {
  logged: boolean
  user: Representative
  token: string
  refreshToken: string
  isLoading: boolean
  error: string | null
  refreshExpiresIn: number
  accessExpiresIn: number
  userForgotPassword: RecoverPasswordRepresentativeCommandResponse | null
}
